export const effectivedatetypes = [
    {val: 'agrcreation', short: 'manually defined', long: 'Defined manually upon agreement creation' },
    {val: 'signoff', short: 'last signature', long: 'Automatically updated upon the last sign-off of the agreement'},
    {val: 'smartfield', short: 'smartfield', long: 'Defined inside the agreement (through a smartfield)'},
];